import React from "react";
import { ChlCardIcon } from "../../Admin/Checklist/ChlCardIcon";
import "./KPICard.scss";

// Card de KPI reutilizable entre dashboards — mismo estilo ya aplicado en
// Inicio (GeneralDashboard), pensado para que los próximos dashboards lo
// importen en vez de copiar el bloque de nuevo.
//
// `progressColor` acepta un hex ("#A3B76B") o el nombre de una clase de
// color ya definida en progress-fill (ej. "green"/"orange"/"red", como usa
// el semáforo de cumplimiento de Checklist).
export function KPICard({ label, value, rawValue, showProgress, progressColor = "blue", subtitle }) {
  return (
    <div className={`kpi-card resumen-card${!showProgress ? " no-progress" : ""}`}>
      <div className="card-meta">
        <div className="card-title-row">
          <span className="kpi-card__title-group">
            <span className="kpi-card__icon"><ChlCardIcon /></span>
            <span className="card-title">{label}</span>
          </span>
          {subtitle && <span className="card-subtitle">{subtitle}</span>}
        </div>
      </div>
      {showProgress ? (
        <div className="progress-container">
          <div className="kpi-card__progress-row">
            <div className="progress-bar">
              <div
                className={progressColor.startsWith("#") ? "progress-fill" : `progress-fill ${progressColor}`}
                style={{ width: `${rawValue}%`, ...(progressColor.startsWith("#") ? { backgroundColor: progressColor } : {}) }}
              />
            </div>
            <span className="kpi-card__progress-max">100%</span>
          </div>
        </div>
      ) : (
        <div className="empty-space" />
      )}
      <div className="card-header">
        <span>{value}</span>
      </div>
    </div>
  );
}
